// ----------------------------------------------------------------------------
// Template: Index
// ----------------------------------------------------------------------------
// Home Page Template
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/country-modal/country-modal';
import 'sections/hero-banner/hero-banner';
import 'sections/intro-block/intro-block';
import 'sections/collection-list/collection-list';
import 'sections/banner/banner-block';
import 'sections/icon-block/icon-block';
import 'sections/content-panel/content-panel';
import 'sections/content-cards/content-cards';
import 'sections/faqs/faqs';
import 'sections/testimonial/testimonial';
import 'sections/featured-collection/featured-collection';
import 'sections/featured-products/featured-products';
import 'sections/blog-posts/blog-posts';
import 'sections/related-blogs/related-blogs';
import 'sections/newsletter/newsletter';
import 'sections/footer/footer';

// Styles
